<div class="full-screen-panel" [class.full-screen]="fullScreen()">
  <wr-full-screen-button *ngIf="buttons"></wr-full-screen-button>
  <ng-content></ng-content>
</div>
